export const projects = [
  {
    title: "Plum Goodness (EsMagico's Project)",
    subtitle: "TECH STACK: Flutter | Dart |  Firebase | LocalStorage | GetX",
    description:
      "New Age Vegan D2C brand for skincare, hair, body and make-up. has more than 1 million active users",
    responsibility:
      "Responsibilitys: Developed Home page, Category Explorer page,Product Cards,Shop now page etc.",
    team: "A cooperative Project worked by a group of 3 members",
    image: "./images/plum.jpg",
    gitlink: "#",
    link: "https://play.google.com/store/apps/details?id=com.esmagico.plum&hl=en&gl=US",
  },
  {
    title: "The Pawfect Date (EsMagico's Project)",
    subtitle:
      "TECH STACK: Flutter | Dart | Agora SDK | Firebase | LocalStorage | GetX",
    description:
      "The Pawfect Date: Matchmaking for Dogs. Find your furry friend's perfect Partner ",
    responsibility: "Responsibilitys: An individual project ",
    team: "I built from scratch and executed in just a month",
    image: "./images/pawfect.jpg",
    gitlink: "#",
    link: "https://drive.google.com/file/d/1ZSmEPvIvr33DooXYPF3SQy3enBj03_8l/view",
  },
  {
    title: "LifeTalk (EsMagico's Project)",
    subtitle:
      "TECH STACK: Flutter | Dart | GetX | Agora SDK | Firebase | LocalStorage",
    description:
      "Lifetalk is app that instantly connects you to verified Tarot Readers and curated Emotional Wellness Experts. Easing your troubles are just a talk away. ",
    responsibility:
      "Responsibilitys: Developed Home page, appointment feature ,Chat, Video Call etc.",
    team: "This project had already 70% done I added these above feature individuality",
    image: "./images/lifetalkIcon.jpg",
    gitlink: "#",
    link: "https://play.google.com/store/apps/details?id=com.lifetalk.thriive&hl=en&gl=US",
  },

  {
    title: "Meesho Clone (Masai School Project)",
    subtitle:
      "TECH STACK: React Native |JavaScript | Firebase | Paper UI | Image Picker | Expo Location | Vector Icons",
    description: `Meesho is a social commerce platform that undertakes
retail distribution, enabling small retail merchants to
connect and sell their products.`,
    responsibility: `Developed Products, Details, Category & User profile Screens & every
logic part was writen by me.`,
    team: " A cooperative Project worked by a group of 2 executed in 7 days.",
    image: "./images/meesho.jpg",
    gitlink: "https://github.com/Vikasyadav3935/Meesho-clone",
    link: "https://drive.google.com/file/d/1qFrxLUczVEdjzgqRab1RouroASTY1BgC/view?usp=sharing",
  },
  {
    title: "Khan sir Books (personal project)",
    subtitle:
      "TECH STACK: Kotlin | Android Studio | Firebase | PDFviewer | Glide | PRDownlaoder | Room Database",
    description: `An android app that provides study materials, provided
by Khan sir.`,
    responsibility: `Personal project entire app built by me.`,
    team: "This app has more than 250K downloads on google play store with 4.5 rating",
    image: "./images/khansirbook.jpg",
    gitlink: "",
    link: "https://play.google.com/store/apps/details?id=com.techidea.khansirncertbooks",
  },

  {
    title: "OLX Clone (Masai School Project)",
    subtitle: "TECH STACK: React | chakra-ui | React-icons ",
    description:
      "The OLX is a platform for buying and selling services and goods such as electronics, fashion items, furniture, household goods, cars and bikes.",
    responsibility:
      " Developed the User Profile , Edit Profile, MyAds & Favourite pages",
    team: " A cooperative Project worked by a group of 5 executed in 7 days.",
    image: "./images/olx.avif",
    gitlink: "https://github.com/shivraj32644/Olx-Clone",
    link: "https://olxclone-krishna123.netlify.app/",
  },
  {
    title: "Tripadvisor Clone (Masai School Project)",
    subtitle:
      "TECH STACK: HTML | CSS | JavaScript | JSON Server | LocalStorage",
    description:
      "TripAdvisor.com is a trip-planning website & also can compare prices on hotels and flights.",
    responsibility:
      " Developed Landing Page , Restauarant Page & Details page.",
    team: " A cooperative Project worked by a group of 4 executed in 7 days.",
    image: "./images/trip.PNG",
    gitlink: "https://github.com/Sibghataziz/TripAdvisorClone",
    link: "https://tripadvisor-sibghat.netlify.app/",
  },
  {
    title: "Rodhan & Feilds (Masai School Project)",
    subtitle:
      "TECH STACK: HTML | CSS | JavaScript | JSON Server | LocalStorage",
    description:
      "Rodan + Fields is a leading skincare brand founded in 2000 with a passion for giving people the best skin of their lives — and the confidence that comes with it.",
    responsibility: " Developed Home page.",
    team: " A cooperative Project worked by a group of 4 executed in 7 days.",
    image: "./images/roda.PNG",
    gitlink: "https://github.com/itsvikasdwivedi/Team-Rodan",
    link: "https://effortless-kataifi-dd52d4.netlify.app/landingpage/landing",
  },
];
